//Libraries
import _ from 'lodash'
import moment from 'moment'

//Components
import ListView from './listView'
import Section from '../../components/section'
import Header from '../../components/pageHeader'
import LongPress from '../../components/longPress'
import SectionSpacing from '../../components/sectionSpacing'
import CalendarComponent from '../../components/calendar.js'

//Styling
import './classBookings.scss'
import '../../dashboard.scss'
import colours from './../../utilities/colours.scss'

//Functions and Data
import config from './config'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import React, { useEffect, useState, useRef } from 'react'
import { fetchAll } from '../../../../modules/users'
import { sendRequest } from '../../../../modules/admin'
import { fetchClass } from '../../../../modules/bookings'
import { isEqualDate, keys2 as keys } from '../../utilities/calendarData.js'
import {
  StateProvider as CalendarProvider,
  initialState,
  reducer,
  useStateValue
} from './classBookings.context'

function CalendarManager({ bookings, sendRequest }) {
  const [{ controllers }, dispatch] = useStateValue()
  const [bookingsMap, setBookingsMap] = useState(new Map())
  const [inputDate, setInputDate] = useState('')
  const calendarRef = useRef(null)
  const notThisMonth = () => _.clone({ backgroundColor: colours.lightGray })

  useEffect(() => {
    var newBookingsMap = new Map()

    bookings.forEach(booking => {
      var toAdd = booking.classDates
        ? booking.classDates
        : [{ classDate: booking.classDate, classTime: booking.classTime }]

      toAdd.forEach(classDate => {
        var date = moment(classDate.classDate).format('DD-MM-YYYY')

        if (newBookingsMap.has(date)) {
          newBookingsMap.set(date, newBookingsMap.get(date) + 1)
        } else {
          newBookingsMap.set(date, 1)
        }
      })
    })

    setBookingsMap(newBookingsMap)
    dispatch({ type: 'updateBookings', bookings: bookings })
  }, [bookings])

  const getSelected = () => {
    const { userAction, selectedDates } = controllers
    var dates = []

    if (userAction === 'selectRange') {
      var now = selectedDates[0].clone()

      while (now.isSameOrBefore(selectedDates[1])) {
        dates.push(now.format('DD-MM-YYYY'))
        now.add(1, 'days')
      }
    } else if (userAction === 'selectDates') {
      selectedDates.forEach(date => {
        dates.push(date.format('DD-MM-YYYY'))
      })
    }

    return bookings.filter(booking => {
      if (booking.classDates) {
        for (var i = 0; i < booking.classDates.length; i++) {
          var date = booking.classDates[i].classDate

          return dates.includes(moment(date).format('DD-MM-YYYY'))
        }
      } else {
        return dates.includes(moment(booking.classDate).format('DD-MM-YYYY'))
      }
    })
  }

  const getStyle = (date, sameMonth) => {
    var isSelected = false
    if (
      controllers.userAction === 'selectRange' &&
      controllers.selectedDates.length === 2
    ) {
      var matchOne =
        isEqualDate(controllers.selectedDates[0], date) ||
        isEqualDate(controllers.selectedDates[1], date)
      var matchTwo = date.isBetween(
        controllers.selectedDates[0],
        controllers.selectedDates[1]
      )
      isSelected = matchOne || matchTwo
    } else if (controllers.userAction !== null) {
      var foundDate = controllers.selectedDates.find(selectedDate =>
        isEqualDate(date, selectedDate)
      )
      if (foundDate && foundDate !== null) {
        isSelected = true
      }
    }

    var style = { backgroundColor: 'white' }
    if (!sameMonth) {
      return notThisMonth()
    } else if (isSelected) {
      style.borderWidth = 3
      style.borderStyle = 'solid'
      style.borderColor = colours.darkPrimary
    }

    return style
  }

  const renderView = (date, i, sameMonth, cellHeight) => {
    var formattedDate = date.format('DD-MM-YYYY')
    return (
      <LongPress
        key={i}
        longPressTime={1000}
        onShortPress={() => onPress(date)}
        onLongPress={() => onLongPress(date)}
        className="calenderDate"
        style={{ height: cellHeight, ...getStyle(date, sameMonth) }}>
        {Number(date.format('DD'))}
        {bookingsMap.has(formattedDate) && <div className="bookingDot"></div>}
      </LongPress>
    )
  }

  const getKeyView = (key, i) => {
    return (
      <div key={i} className={key.style + ' calendarKey'}>
        {key.name}
      </div>
    )
  }

  const onLongPress = date =>
    dispatch({
      type: 'userAction',
      userAction: 'selectRange',
      selectedDate: date
    })

  const onPress = date =>
    dispatch({
      type: 'userAction',
      userAction: 'selectDates',
      selectedDate: date
    })

  // --- Date input handlers for navigating the calendar ---
  const onDateInputChange = e => {
    setInputDate(e.target.value)
  }

  const onDateInputGo = () => {
    if (!inputDate) return
    const inputMoment = moment(inputDate, 'YYYY-MM-DD')
    if (!inputMoment.isValid()) return
    // Jump the calendar to the correct month/year and select the specific date ONLY (override selection)
    // Use ref to call method on CalendarComponent, and update selection context
    // CalendarComponent exported with a ref for imperative methods
    if (calendarRef.current && calendarRef.current.gotoDate) {
      calendarRef.current.gotoDate(inputMoment)
    }
    dispatch({
      type: 'userAction',
      userAction: 'selectDates',
      selectedDate: inputMoment,
      replaceSelection: true
    })
  }

  // Allow input to be submitted with Enter key
  const onDateInputKeyDown = e => {
    if (e.key === 'Enter') {
      onDateInputGo()
    }
  }

  return (
    <div className="calendarManager">
      {controllers.userAction !== null && <ListView bookings={getSelected()} />}
      <SectionSpacing />
      <div className="calederWithKeys">
        <div className="calendarSection">
          <CalendarComponent renderView={renderView} ref={calendarRef} />
        </div>
        <SectionSpacing />
        <Section title={config.keysSection} height={'auto'}>
          <div className="calendarKeys">{keys.map(getKeyView)}</div>
        </Section>
      </div>
      {/* Date input for navigating to a specific date */}
      <div className="calendarDateInputContainer" style={{ marginBottom: 16 }}>
        <label htmlFor="calendar-jump-date" style={{ marginRight: 8, fontWeight: 'bold' }}>
          Go to date:
        </label>
        <input
          type="date"
          id="calendar-jump-date"
          value={inputDate}
          onChange={onDateInputChange}
          onKeyDown={onDateInputKeyDown}
          style={{ marginRight: 8, padding: 2 }}
        />
        <button onClick={onDateInputGo} style={{ padding: '2px 10px' }}>
          Go
        </button>
      </div>
    </div>
  )
}

// refreshData = () => {
//   this.props.sendRequest(fetchAll)
//   this.props.sendRequest(fetchParty, { date: this.state.switchDate })
//   this.props.sendRequest(fetchPlayonly, { date: this.state.switchDate })
//   this.props.sendRequest(fetchClass, { date: this.state.switchDate })
// }

function ClassBookings({ isOpen, sendRequest, bookings, users }) {
  const [tab, setTab] = useState(0)
  const [tabs, setTabs] = useState([])

  useEffect(() => {
    sendRequest(fetchAll)
    var cb = i => setTab(i)

    setTabs([
      { name: 'Calendar', cb: () => cb(0) },
      { name: 'List', cb: () => cb(1) }
    ])
  }, [])

  useEffect(() => {
    if (users.length > 0) {
      sendRequest(fetchClass)
    }
  }, [users])

  useEffect(() => {
    console.log({ bookings })
  }, [bookings])

  return (
    <div className={'component' + (isOpen ? '' : ' componentClosed')}>
      <Header
        title={config.mainTitle}
        tip={config.subHeading}
        icon={config.titleIcon}
        tabs={tabs}
        selected={tab}
      />
      {tab === 1 && <ListView bookings={bookings} />}
      {tab === 0 && (
        <CalendarProvider initialState={initialState} reducer={reducer}>
          <CalendarManager bookings={bookings} sendRequest={sendRequest} />
        </CalendarProvider>
      )}
    </div>
  )
}

const mapStateToProps = ({ bookings, users }) => ({
  users: users.users,
  bookings: bookings.classBookings
})

const mapDispatchToProps = dispatch =>
  bindActionCreators({ sendRequest }, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClassBookings)
